module.exports = "\r\n@import url('https://fonts.googleapis.com/css?family=Ubuntu:400,500,700');\n/* @import '/../assets/css/style.css'; */\n/* @import url('https://fonts.googleapis.com/css?family=Roboto+Condensed:400,700'); */\n/* ::ng-deep body {\r\n    font-family: 'Roboto Condensed', sans-serif;\r\n}\r\n::ng-deep body * {\r\n    font-family: 'Roboto Condensed', sans-serif;\r\n} */\n::ng-deep body {\r\n    font-family: 'Ubuntu', sans-serif;\r\n}\n::ng-deep body * {\r\n    font-family: 'Ubuntu', sans-serif;\r\n}\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main